export const myDailyFortune = {
  name: "My Daily Fortune",
  excerpt: "Daily Fortunes",
  image: "simpleLeadTracker.webp",
  localUrl: "my-daily-fortune",
  url: "#",
  alternateUrl: "#",
  description: "My Daily Fortune is a mobile app that lets users generate a new fortune every day. It is currently available for both IOS and Android devices.",
  challenge: "This was one of our first mobile app projects, so it involved a lot of learning on how to actually deploy a mobile app. We wanted to deploy for both Android and IOS devices, and each process is slightly different. This was also a good opportunity for us to create a framework for deploying mobile apps as we wanted to release more in the future.",
  solution: "We built My Daily Fortune as a Javascript based web app, and then packaged it for deployment with Cordova. This allowed us to write in a farmiliar language, while still making our deploy target mobile devices. We also used thus project as a test to build our first API in Clojure since it's a fairly simple one.",
  tech: ["Cordova", "Clojure", "jQuery"],
  images: ["simpleLeadTracker.webp", "simpleLeadTracker.webp", "simpleLeadTracker.webp"]
}
